import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import React, { ChangeEvent, FC } from "react";
import {
  WrappedComponentProps,
  injectIntl,
  FormattedMessage,
} from "react-intl";
import { GENDER_ITEMS, SAPHEER_COLOR } from "../../../utils/constant";
import { GetListSelect } from "../../../utils/selectItems";
import {
  COUNTRIES_EN,
  COUNTRIES_FR,
  DEFAULT_COUNTRY_CODE,
} from "../../../constants/countries";
import { CreateUserInput } from "../../../types/graphql-global-types-onboarding";
import CustomSelect from "../../Ui/CustomSelect";
import CustomCheckBox from "../../Ui/CustomCheckBox";
import CustomDate from "../../Ui/CustomDate";
import CustomTextField from "../../Ui/CustomTextField";
import { country } from "../../../constants/country";
interface PersonProps {
  information: CreateUserInput;
  isSubmitted?: boolean;
  handleDateChange: (name: string, date: any) => void;
  handleInputChange(event: ChangeEvent<HTMLInputElement>): void;
  handleSelect(name: string, value: string): void;
}

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
  },
  doubleInput: {
    display: "flex",
    "& > *": {
      width: "calc(50% - 8px)",
      maxWidth: 450,
    },
    "& > *:first-child": {
      marginRight: theme.spacing(2),
    },
    "@media (max-width: 1308px)": {
      display: "block",
      "& > *": {
        width: "100%",
      },
      "& > *:first-child": {
        marginRight: 16,
      },
    },

    "@media (max-width: 826px)": {
      display: "block",
      "& > *": {
        width: "100%",
      },
      "& > *:first-child": {
        marginRight: 0,
      },
    },
  },
  text: {
    fontSize: ".75rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",
  },
}));

const Person: FC<PersonProps & WrappedComponentProps> = (props) => {
  const {
    intl,
    information,
    handleInputChange,
    handleSelect,
    handleDateChange,
  } = props;
  const isSubmitted = props.isSubmitted ? props.isSubmitted : false;
  const classes = useStyles();
  return (
    <Box className={classes.content}>
      <CustomSelect
        setValue={handleSelect}
        options={GENDER_ITEMS}
        name="gender"
        value={information.gender || ""}
        isSubmitted={isSubmitted}
        label={intl.formatMessage({ id: "member.form.gender" })}
      />
      <Box className={classes.doubleInput}>
        <CustomTextField
          name="firstname"
          label={intl.formatMessage({ id: "member.form.surname" })}
          placeholder="Prénom..."
          onChange={handleInputChange}
          value={information?.firstname}
          isSubmitted={isSubmitted}
        />
        <CustomTextField
          name="name"
          label={intl.formatMessage({ id: "member.form.name" })}
          placeholder="Nom..."
          onChange={handleInputChange}
          value={information?.name}
          isSubmitted={isSubmitted}
        />
      </Box>
      <CustomSelect
        setValue={handleSelect}
        options={GetListSelect(country, country)}
        name="nationalityCountryIsoCode"
        value={information?.nationalityCountryIsoCode || DEFAULT_COUNTRY_CODE}
        isSubmitted={isSubmitted}
        label={intl.formatMessage({ id: "member.form.citizenShip" })}
      />

      <CustomDate
        label={"Date de naissance"}
        name="dateOfBirth"
        handleDateChange={handleDateChange}
        errorMessageId="maxdate.message"
        isSubmitted={isSubmitted}
        type="date"
        value={information?.dateOfBirth || undefined}
        maxDate={new Date()}
      />

      <CustomTextField
        name={"cityOfBirth"}
        label={"Ville de naissance"}
        placeholder="Ville..."
        onChange={handleInputChange}
        value={information.cityOfBirth}
        isSubmitted={isSubmitted}
      />

      <CustomSelect
        setValue={handleSelect}
        options={GetListSelect(country, country)}
        name="countryOfBirthIsoCode"
        value={information?.countryOfBirthIsoCode || DEFAULT_COUNTRY_CODE}
        isSubmitted={isSubmitted}
        label={"Pays de naissance"}
      />
      <CustomCheckBox
        allPointer
        name="isDirector"
        isChecked={!!information.isDirector}
        onCheck={handleInputChange}
        label={
          <Typography
            className={classes.text}
            style={{ fontWeight: "bold", color: SAPHEER_COLOR }}
          >
            <FormattedMessage id="member.isDirector" />
          </Typography>
        }
      />
      {information?.isDirector && (
        <CustomDate
          label={intl.formatMessage({
            id: "member.director.appointment.date",
          })}
          name="directorAppointmentDate"
          handleDateChange={handleDateChange}
          errorMessageId="maxdate.message"
          isSubmitted={isSubmitted}
          type="date"
          value={information?.directorAppointmentDate || undefined}
          maxDate={new Date()}
        />
      )}

      <CustomCheckBox
        allPointer
        name="specifiedUSPerson"
        isSubmitted={isSubmitted}
        isChecked={!!information.specifiedUSPerson}
        onCheck={handleInputChange}
        label={
          <Typography
            className={classes.text}
            style={{ fontWeight: "bold", color: SAPHEER_COLOR }}
          >
            <FormattedMessage id="member.certify.usSpecifiedPerson" />
          </Typography>
        }
        errorMessage={<FormattedMessage id="member.usPerson.empty" />}
      />
    </Box>
  );
};
export default injectIntl(Person);
